import { createAction, props } from '@ngrx/store';
import {
  DabData,
  DabHistory,
  ProductKey,
} from 'graphql-api/gql-api-interfaces';

/**
 * Makes a GQL request to fetch filters
 */
export const loadDab = createAction(
  '[ProductBasket] Load DAB',
  props<{
    products: ProductKey[];
  }>(),
);

/**
 * Updates the state on response success of the filters query in GQL
 */
export const loadDabSuccess = createAction(
  '[ProductBasket] Load DAB Success',
  props<{ dabData: DabData[] }>(),
);

export const clearDab = createAction('[ProductBasket] Clear DAB');

export const updateDab = createAction(
  '[ProductBasket] Update DAB',
  props<{ dabData: DabData[] }>(),
);

/**
 * Updates the state on response success of the filters query in GQL
 */
export const loadDabFailure = createAction(
  '[ProductBasket] Load DAB Failure',
  props<{ error: string }>(),
);

export const loadDabHistory = createAction(
  '[ProductBasket] Load DAB History',
  props<{
    products: ProductKey[];
  }>(),
);

export const loadDabHistorySuccess = createAction(
  '[ProductBasket] Load DAB History Success',
  props<{ dabHistoryData: DabHistory[] }>(),
);

export const loadDabHistoryFailure = createAction(
  '[ProductBasket] Load DAB History Failure',
  props<{ error: string }>(),
);
